import React from "react";
import "./events.scss";

const Events = () => {
  return (
    <div className="events">
      <div className="events-body">
        <iframe
          src="https://sagarevents.sistec.ac.in/"
          title="Saga Events"
        ></iframe>
      </div>
    </div>
  );
};

export default Events;
